// extracted by mini-css-extract-plugin
export default {"table_header_name":"SalespersonDashboard_table_header_name__7jKqS"};